<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :disabled="disabled"
      :hasVc="hasVc"
      @reload="getData"
    >
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_sku_header_title') || '产品明细列表' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseAmzSku()"
              v-if="!disabled"
            >
              {{ $l('btn_chooseAmzSku') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </div>
      <template #toolbar_btn v-if="disabled">
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="ftyInvOutNoticeDetailList"
          style="margin-right: 0.8em;"
          @change="getData"
        />
      </template>
    </Main>

    <ChooseAmzRegionFtySku
      :visible.sync="chooseAmzSkuOptions.visible"
      :title="chooseAmzSkuOptions.title"
      :scmCode="scmCode"
      :hasVc="hasVc"
      :ecomWarehouseCode="ecomWarehouseCode"
      :amazonStoreRegion="amazonStoreRegion"
      :regionCode="regionCode"
      @confirm="skuConfirm"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseAmzRegionFtySku from '@/views/ecom/components/choose-amz-region-fty-sku'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { Main, ChooseAmzRegionFtySku, SortFieldsPopover },
  props: {
    disabled: { type: Boolean, default: false },
    amzFtyNoticeOutCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    scmName: { type: String, default: '' },
    ecomWarehouseCode: { type: String, default: '' },
    shipmentByFactory: { type: String, default: '' },
    amazonStoreRegion: { type: String, default: '' },
    amazonStoreRegionName: { type: String, default: '' },
    regionCode: { type: String, default: '' },
    regionName: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      sortFields: [],
      chooseAmzSkuOptions: {
        visible: false,
        title: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    hasVc() {
      return this.isVc == 'Y'
    },
  },
  methods: {
    async getData() {
      if (!this.amzFtyNoticeOutCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFtyNoticeOutDetailListApi({
          amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
          sortFields: this.sortFields,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const { data } = res.body
      this.$refs.main.setData(data || [])
    },
    chooseAmzSku() {
      if (!this.amazonStoreRegion) {
        this.$message.warning(this.$l('tips_chooseAmzSku_amazonStoreRegion'))
        return
      }
      if (!this.regionCode) {
        this.$message.warning(this.$l('tips_chooseAmzSku_region'))
        return
      }
      if (!this.scmCode) {
        this.$message.warning(this.$l('tips_chooseAmzSku_Scm'))
        return
      }
      if (!this.ecomWarehouseCode && this.shipmentByFactory === 'N') {
        this.$message.warning(this.$l('tips_chooseAmzSku_ecomWarehouse'))
        return
      }

      const title = [this.amazonStoreRegionName, this.regionName, this.scmName]
        .filter(Boolean)
        .join('-')
      this.chooseAmzSkuOptions = { visible: true, title }
    },
    async skuConfirm(data) {
      if (!data || !data.length) return
      data = data.map((item) => ({
        ...item,
        amzSkuNo: item.amzSkuNo,
        amzStoreSkuNo: item.storeSkuNo,
        ncNo: item.ftyNcNo || item.ncNo,
      }))
      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
